/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type InternalCheckStatusPep =
  typeof InternalCheckStatusPep[keyof typeof InternalCheckStatusPep];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InternalCheckStatusPep = {
  NO_MATCH: 'NO_MATCH',
  TRUE_MATCH: 'TRUE_MATCH',
  INCONCLUSIVE: 'INCONCLUSIVE',
} as const;
